import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LoadingContext } from '../../contexts';
import DefaultSection, { DefaultSubSectionTitle, HorizontalRule } from '../../components/default_section/default_section';
import DefaultInput, { SelectOption } from '../../components/default_input/default_input';
import WarningMessage from '../../components/warning_message/warning_message';
import { AuthContext } from '../../contexts';
import { EDIT_COMPLAINT_CASE_NOTES_PERMISSION, 
         FILL_COMPLAINT_CASE_FORM_PERMISSION,
         FINISH_COMPLAINT_CASE_PERMISSION,
         VIEW_COMPLETE_COMPLAINT_CASE_PERMISSION } from '../../constants/permissions';
import { COMPLAINT_CASE_FORM_PATH } from '../../constants/paths';
import { getAsLocalDateString } from '../../utils/functions';
import './complaint_case_data.scss';

class ComplaintCaseData extends React.Component {
  handleKeyDown(event) {    
    if(event.keyCode === 13 && this.props.enableSave && !this.props.isLoading) {
      this.props.onSave();
    }
  }

  isHighlighted(propertyName) {
    return this.props.highlights.includes(propertyName);
  }

  getPatientOptions() {
    const options = this.props.patients.map((patient) => SelectOption(patient.id, patient.name));

    if (this.props.complaint_case.patient_id && this.props.complaint_case.patient_id > 0) {
      return options;
    }

    return [
      SelectOption('', 'Selecione um paciente'),
      ...options
    ];
  }

  getResult() {
    if (this.props.complaint_case.result === null) {
      return null;
    }

    if (this.props.complaint_case.result.length <= 0) {
      return (
        <h3 className="complaint-case-data__no-result-text">Nenhuma queixa cadastrada!</h3>
      );
    }

    const complaintTypeElements = [];
    const results = [];
    const scores = []

    for (const entry of this.props.complaint_case.result) {
      complaintTypeElements.push(
        <div 
          key={`result_table:complaint_type:${entry.complaint_type.name}`}
          className="complaint-case-data__result-table__column__row"
        >

          <p className="complaint-case-data__result-table__column__row__text">{entry.complaint_type.name}</p>

        </div>
      );

      results.push(
        <div 
          key={`result_table:complaint_type:${entry.complaint_type.name}:result`}
          className={`complaint-case-data__result-table__column__row--${entry.result_weight}`}
        >

          <p className="complaint-case-data__result-table__column__row__text">{entry.result_text}</p>

        </div>
      );

      if (this.props.auth.permission_ids.includes(VIEW_COMPLETE_COMPLAINT_CASE_PERMISSION)) {
        scores.push(
          <div 
            key={`result_table:complaint_type:${entry.complaint_type.name}:result`}
            className={`complaint-case-data__result-table__column__row--${entry.result_weight}`}
          >
  
            <p className="complaint-case-data__result-table__column__row__text">{entry.total_score}</p>
  
          </div>
        );
      }
    }
    
    return (
      <div className="complaint-case-data__result-table">
      
        <div className="complaint-case-data__result-table__column">

          <div className="complaint-case-data__result-table__column__header">

            <h3 className="complaint-case-data__result-table__column__header__text">
              Queixas
            </h3>

          </div>

          {complaintTypeElements}

        </div>
      
        <div className="complaint-case-data__result-table__column">

          <div className="complaint-case-data__result-table__column__header">

            <h3 className="complaint-case-data__result-table__column__header__text">
              Gravidade
            </h3>

          </div>

          {results}

        </div>

        {this.props.auth.permission_ids.includes(VIEW_COMPLETE_COMPLAINT_CASE_PERMISSION) &&
          <div className="complaint-case-data__result-table__column">

            <div className="complaint-case-data__result-table__column__header">

              <h3 className="complaint-case-data__result-table__column__header__text">
                Pontuação
              </h3>

            </div>

            {scores}

          </div>
        }      

      </div>
    );
  }

  render() {
    return (
      <DefaultSection
        className="complaint-case-data"
        title="Dados do caso"
      >

        {this.props.isEdit &&
          <>

            <div className="complaint-case-data__actions-container">

              {this.props.auth.permission_ids.includes(FILL_COMPLAINT_CASE_FORM_PERMISSION) &&
                <>

                  <button
                    className="default-section__default-link-button"
                    onClick={() => this.props.onCopyFormLink()}
                    disabled={this.props.isLoading}
                  >

                    <i className="fas fa-link default-section__default-link-button__icon"></i> {this.props.formLinkCopied ? 'Link copiado' : 'Copiar link do formulário'}

                  </button>
                  
                  <Link
                    className="default-section__default-link-button complaint-case-data__action-button"
                    to={COMPLAINT_CASE_FORM_PATH.replace('{id}', this.props.complaint_case.id)}
                  >

                    <i className="fa-solid fa-list-check default-section__default-link-button__icon"></i> Preencher formulário

                  </Link>

                </>
              }

              {this.props.auth.permission_ids.includes(FINISH_COMPLAINT_CASE_PERMISSION) &&
                <button
                  className="default-section__default-link-button complaint-case-data__action-button--highlight"
                  onClick={() => this.props.onArchiveComplaintCase()}
                  disabled={this.props.isLoading}
                >

                  {this.props.hasFinished ? <i className="fa-solid fa-box-open default-section__default-link-button__icon"></i>  : <i className="fa-solid fa-box default-section__default-link-button__icon"></i>}
                  {this.props.hasFinished ? 'Reabrir caso' : 'Arquivar caso'}

                </button>
              }

            </div>

            <HorizontalRule />

          </>
        }

        <div className="complaint-case-data__warning-container">

          <WarningMessage
            message={this.props.warningMessage}
            onClose={this.props.onCloseWarning}
            visible={this.props.showWarningMessage}
          />

        </div>

        <div className="complaint-case-data__input-container">

          <DefaultInput
            name="patient_id"
            isHighlighted={this.isHighlighted("patient_id")}
            label="Paciente"
            type="select"
            handleInputChange={this.props.handleInputChange}
            value={this.props.complaint_case.patient_id || ''}
            options={this.getPatientOptions()}
            disabled={this.props.isEdit || this.props.isLoading}
          />

          {this.props.auth.permission_ids.includes(EDIT_COMPLAINT_CASE_NOTES_PERMISSION) &&
            <DefaultInput
              name="notes"
              isHighlighted={this.isHighlighted("notes")}
              label="Notas / Observações"
              type="textarea"
              placeholder="Notas sobre o caso"
              rows="4"
              handleInputChange={this.props.handleInputChange}
              value={this.props.complaint_case.notes || ''}
              disabled={this.props.isLoading}
            />
          }

        </div>

        {this.props.complaint_case.form_filled &&
          <>

            <HorizontalRule />

            <DefaultSubSectionTitle
              icon={<i className="fa-solid fa-file-pen"></i>}
              text="Resultado do formulário"
            />

            <p className="complaint-case-data__result__text">
            
              Data do preenchimento: <span className="complaint-case-data__result__text--highlight">{getAsLocalDateString(this.props.complaint_case.form_filled_at)}</span>
            
            </p>

            <p className="complaint-case-data__result__text">
            
              Preenchido por: <span className={`complaint-case-data__result__text--${this.props.complaint_case.username !== null ? 'warning' : 'highlight'}`}>{this.props.complaint_case.username || 'Cliente'}</span>
            
            </p>

            {this.getResult()}

          </>
        }


        <HorizontalRule />

        <div className="complaint-case-data__buttons-container">

          <button
            className="complaint-case-data__save-button"
            disabled={!this.props.enableSave || this.props.isLoading}
            onClick={this.props.onSave}
          >

            Salvar

          </button>

          <Link
            className="complaint-case-data__cancel-button"
            to={this.props.onCancelPath}
            disabled={this.props.isLoading}
          >

            Cancelar

          </Link>

        </div>

      </DefaultSection>
    );
  }
};

const WrappedComplaintCaseData = props => {
  const {isLoading} = useContext(LoadingContext);
  const auth = useContext(AuthContext);

  return (
    <ComplaintCaseData
      isLoading={isLoading}
      auth={auth}
      {...props}
    />
  );
};

export {WrappedComplaintCaseData as ComplaintCaseData};
